<template>
  <div>
    <Header />
    <FlashMessage ref="flashMessage" />

    <div class="product-page">
      <div
        class="categories-sidebar"
        :class="{ 'sidebar-open': isSidebarOpen }"
      >
        <h3 @click="HandleShopMneu()">Shop</h3>
        <ul>
          <li
            v-for="category in categories"
            :key="category.name"
            class="main-category"
            @click="openSubMenu(category.name)"
          >
            <div class="category-header">
              <span>{{ category.name }}</span>
              <span class="dropdown-icon">
                {{ activeSubMenu === category.name ? "▼" : "▶" }}
              </span>
            </div>
            <ul v-if="activeSubMenu === category.name" class="sub-categories">
              <li
                v-for="brand in category.children"
                :key="brand.id"
                @click="HandleProductBrandwise(brand.id, brand.name)"
              >
                {{ brand.name }}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <main>
        <router-view></router-view>
      </main>

      <button class="sidebar-toggle" @click="toggleSidebar">
        <i class="fas fa-bars"></i>
      </button>

      <div
        v-if="isSidebarOpen"
        class="sidebar-overlay"
        @click="toggleSidebar"
      ></div>

      <FloatingActionButton />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import Header from "@/components/Header.vue";
import LoadingIndicator from "@/components/Loading_indicator.vue";
import { fetchCategorieswithBrand } from "@/API-requests/Requests";
import FlashMessage from "@/components/FlashMessage.vue";
import FloatingActionButton from '@/components/FloatingMenu.vue'


const router = useRouter();

const loading = ref(true);
const error = ref(null);
const flashMessage = ref(null);
const categories = ref([]);

onMounted(async () => {
  try {
    const menusData = await fetchCategorieswithBrand();
    categories.value = menusData;
  } catch (err) {
    console.error("Error fetching categories:", err);
    error.value = "Failed to load categories. Please try again later.";
    flashMessage.value.showFlashMessage(
      "failure",
      "There was an issue preparing your menu!"
    );
  } finally {
    loading.value = false;
  }
});

const HandleProductBrandwise = (brand_id, brand_name) => {
  router.push({
    name: "ProductBrandwise",
    params: { brand_id, brand_name },
  });
};

const HandleShopMneu = () => {
  router.push("/product");
};
const activeSubMenu = ref(null);
const openSubMenu = (categoryName) => {
  activeSubMenu.value = categoryName;
};

const isSidebarOpen = ref(false);
const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value;
};
</script>
<style scoped>
.product-page {
  display: flex;
  padding-top: 80px;
  gap: 20px;
  position: relative;
}

.categories-sidebar {
  width: 250px;
  padding: 20px;
  background-color: #2c3e50;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 60px;
  left: 0px;
  bottom: 20px;
  overflow-y: auto;
  z-index: 1000;
  transition: transform 0.3s ease;
}

.categories-sidebar h3 {
  margin-bottom: 15px;
  font-size: 18px;
  cursor: pointer;
  color: #fff;
}

.categories-sidebar ul {
  list-style: none;
  padding: 0;
}

.categories-sidebar .main-category {
  margin-bottom: 10px;
}

.categories-sidebar .category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  background-color: #fff;
  transition: background-color 0.3s ease;
}

.categories-sidebar .category-header:hover {
  background-color: #f0f0f0;
}

.categories-sidebar .dropdown-icon {
  font-size: 12px;
  color: #666;
}

.categories-sidebar .sub-categories {
  margin-top: 5px;
  padding-left: 20px;
}

.categories-sidebar .sub-categories li {
  margin-bottom: 5px;
  font-size: 14px;
  color: #555;
  cursor: pointer;
  padding: 2px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #fafafa;
  transition: background-color 0.3s ease;
}

.categories-sidebar .sub-categories li:hover {
  background-color: #f0f0f0;
  color: #cc0000;
}

/* Toggle Button for Mobile */
.sidebar-toggle {
  display: none;
  position: fixed;
  top: 60px;
  left: 3px;
  /* background-color: rgb(215, 55, 55); */
  background-color: rgb(212, 175, 55);
  color: #fff;
  border: none;
  padding: 14px;
  border-radius: 2px;
  cursor: pointer;
  z-index: 999;
}

/* Sidebar Overlay for Mobile */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 900;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sidebar-toggle {
    display: block;
  }

  .categories-sidebar {
    transform: translateX(-100%);
    top: 7.5rem;
    bottom: 0;
    left: 0;
    width: 200px;
    z-index: 999;
  }

  .categories-sidebar.sidebar-open {
    transform: translateX(0);
  }

  .product-page {
    padding-top: 1px;
  }
}
</style>
